import React, { useEffect, useState } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import acadamic_calendar from "../../assets/acadamic_calendar.jpg";
import "./AcadamicCalender.css";
import axios from "axios";
import { resources } from "../Resourses/Resources";
import { DownloadIcon } from '@mui/icons-material/Download';
const AcadamicCalender = () => {
  const [years, setYears] = useState([]);
  const [year, setYear] = useState("")
  const[course, setCourse] = useState("")
  const [courses, setCourses] = useState([]);
  const [ pdf, setPdf] = useState("")
  const getAcYear = async () => {
    try{
      const res = await axios.get(`${resources.APPLICATION_URL}academicCalendar/getDistinctAcademicYears`)
      setYears(res.data)
      console.log("Acyear---",res.data)
    }catch(err){
      console.error('Eroor fetching Acyear', err)
    }
  }
  useEffect(() => {
    getAcYear()
  },[])
  const getCourse = async (year) => {
    if (!year) return; // Avoid calling API if year is falsy
    try {
      const res = await axios.get(`${resources.APPLICATION_URL}academicCalendar/getCourseByParams?accYear=${year}`, {
      });
      setCourses(res.data)
      console.log("course year-----", res.data); // Logging res.data instead of whole response
    } catch (err) {
      console.error("course data not available", err);
    }
  };
  useEffect(() => {
    getCourse(year);
  }, [year]);
  const getingData = async (academicYear, course) => {
    try {
      const res = await axios.get(`${resources.APPLICATION_URL}academicCalendar/getAcademicCalendar`, {
        params: {
          academicYear,
          course,
        },
      });   setPdf(res.data.msg)
            console.log('Academic Calender respones:', res.data.msg);
    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };
  useEffect(() => {
  if (year && course) {
    getingData(year, course);
  }
}, [year, course]);
const [blob, setBlob] = useState("")
const openPdfFromBase64 = () => {
  if(!pdf || pdf ==='File not found!!!') {
    alert('file not found')
    return
  }
  const base64String = pdf; // full base64 here
  const byteCharacters = atob(base64String);
  const byteArray = new Uint8Array([...byteCharacters].map(c => c.charCodeAt(0)));
  const blob = new Blob([byteArray], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  window.open(url);
};
  return (
    <div className="acadamic_calendar_bg_cnt">
      <div className="page_header" style={{ backgroundColor: "#2C268A" }}
 >
        <h1>Acadamic Calender</h1>
      </div>
      <div class="d-flex flex-column align-items-center justify-content-center year_select_cnt">
        <label>Download Acadamic Calender Here</label>
        <div className="all_dropdown_container">
          <div className="year_select_cnt">
            <label>Academic Year</label>
            <select
              value={year}
              onChange={(e) =>    setYear(e.target.value)}
              className="select text-center"
            >
              {/* <option disabled>Select Acadamic Year</option>
              <option value="">Please Select</option>
              <option value="2014-15">2014-15</option>
              <option value="2015-16">2015-16</option>
              <option value="2016-17">2016-17</option>
              <option value="2017-18">2017-18</option>
              <option value="2018-19">2018-19</option>
              <option value="2019-20">2019-20</option>
              <option value="2020-21">2020-21</option>
              <option value="2021-22">2021-22</option>
              <option value="2022-23">2022-23</option>
              <option value="2023-24">2023-24</option>
              <option value="2024-25">2024-25</option> */}
                <option value="">Please Select</option>
              {years.map((item) =>(
                <option key={item} value={item}>{item}</option>
              ))}
            </select>
          </div>
          <div className="year_select_cnt">
            <label>Courses</label>
            <select
              value={course}
              onChange={(e) => setCourse(e.target.value)}
              className="select text-center"
            >
              {/* <option disabled>Select Course</option>
              <option value="">Please Select</option>
              <option value="UG">Ug</option>
              <option value="Pg">Pg</option>
              <option value="Diploma">Diploma</option> */}
               <option value="">Please Select</option>
               {courses?.map((item) =>(
                <option key={item} value={item}>{item}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="row-12 text-center download_cnt mt-5">
        <label className="">
          Click Here For Download
        </label>
        <br />
        {year  ? (
          // <
          //   id="links_ug"
          //   target="blank"
          //   href={(pdf  && pdf !== "File not found!!!") ? `http://saispurthi.ac.in/docs/acalender/ug_ac_${year}.pdf`: '#'}
          //   style={{
          //     textDecoration: "none",
          //     border: "1px solid orange",
          //     padding: "30px",
          //   }}
          // >
            <FileDownloadIcon fontSize="large" sx={{ fontSize: 50 }} onClick={openPdfFromBase64} />
          
        ) : (
          // <a
          //   style={{
          //     textDecoration: "none",
          //     border: "3px solid orange",
          //     padding: "30px",
          //   }}
          //   id="links_ug"
          //   target="_self"
          //   href={`/acadamics/acadamicCalender`}
          // >
            <FileDownloadIcon
              sx={{ fontSize: 50, color: "orange" }}
              fontSize="large"
            />
          // </a>
        )}
      </div>
    </div>
  );
};
export default AcadamicCalender;









